/**
 * OKS-608 — Shared normalization for Inertia field errors across the
 * candidate inline editors (email, notes, tags).
 *
 * An Inertia field-error can reach the FE in two shapes depending on the
 * source:
 *   - **`<Form>` render-prop `errors`** (email, notes): a value that may be
 *     a single `string` OR a `string[]` (the server sends
 *     `@candidate.errors.to_hash` → arrays, but inertia_rails may flatten a
 *     single-message field to a bare string — OKS-601 EE4).
 *   - **`router.patch` `onError(errors)`** (tags): a `Record<string, string>`
 *     whose per-field value is a bare `string`. The caller extracts the
 *     field (`errors.tags`) and passes it here.
 *
 * `toMessages` collapses both into the `string[] | undefined` shape the
 * `InputError` component expects. Without this, `InputError`'s
 * `messages.join(", ")` throws on a bare string and silently swallows the
 * error (the OKS-601 EE4 failure class).
 *
 * Behavior is intentionally identical to the file-local `toMessages` this
 * replaces in `candidate-email-field.tsx` (OKS-601), so repointing the email
 * field to this shared helper is a pure no-op — the email EE4 regression
 * guard must stay green.
 *
 * NOTE (OKS-608 scope, KD4): the same normalization is duplicated in
 * ≥5 other call sites (add-candidate-dialog, charter-values-editor,
 * reset-acquisition-dialog, settings/profiles/show). Those are DEFERRED to a
 * follow-up ticket — do not fold them in here.
 *
 * @param input a render-prop field error (`string | string[]`) or `undefined`
 * @returns the `string[]` `InputError` renders, or `undefined` when empty
 */
export function toMessages(
  input: string | string[] | undefined,
): string[] | undefined {
  if (!input) return undefined
  return Array.isArray(input) ? input : [input]
}
